import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown, faCloudArrowUp, faSliders, faRefresh } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select'
import { Tooltip } from 'flowbite';
import ColorPicker from 'react-best-gradient-color-picker'
import { toPng  } from 'html-to-image';
import Datetime from 'react-datetime';
import moment from 'moment';
import './TweetCard.css';
import commonFunc from '../common';
import "react-datetime/css/react-datetime.css";

const xIcons= {
  light: 'images/apps/icons8-x.svg',
  dark: 'images/apps/icons8-twitterx.svg',
}

const bgColorReady = commonFunc.bgColorReady

const defaultSettings = {
  imageWidth: 700,
  imageHeight: 700,
  tweetWidth: (700 * 0.7).toFixed(2),
  tweetHeight: null,
  paddingY: 20,
  paddingX: 20,
  nightMode: false
}

const defaultInput = {
  name: 'TOOlover.pro',
  username: 'toolover',
  datetime: new Date(),
  tags: 'toolover, tweet',
  iconX: xIcons.light,
  imageUrl: 'images/logo.png',
  verifiedBadge: null,
  content: 'Hello world! 👋 Do you know that TOOlover.pro offers the best online tool for converting tweets into fancy images with lots of customization options? 🐦 🔄 🖼️',
}

const TweetGenerator = () => {
  const codeRef = useRef();
  const [color, setColor] = useState('linear-gradient(135deg, rgb(54, 209, 220) 0%, rgb(91, 134, 229) 100%)');
  const [imageSettings, setImageSettings] = useState(defaultSettings)
  const [colorTab, setColorTab] = useState(0)
  const [selectBgColorReady, setSelectBgColorReady] = useState(null)
  const [hasBackground, setHasBackground] = useState(true)
  const [aspectRatio, setAspectRatio] = useState('1:1');
  const [inputData, setInputData] = useState(defaultInput)
  const [imageSrc, setImageSrc] = useState('images/logo.svg')

  const handleInputDataChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value })
  }

  const handleHasBackgroundChange = () => {
    const newValue = !hasBackground
    setHasBackground(newValue)
  }

  const handleNightModeChange = () => {
    const newValue = !imageSettings.nightMode
    setImageSettings({
      ...imageSettings,
      nightMode: newValue
    })
  }

  const calculateHeight = (newAspectRatio) => {
    if (newAspectRatio) {
      const [widthRatio, heightRatio] = newAspectRatio.split(':').map(Number);
      const height = (imageSettings.imageWidth * heightRatio) / widthRatio;
      return height
    }
    return defaultSettings.imageHeight
  }

  const options = {
    placement: 'bottom',
    triggerType: 'none',
    onHide: () => {
        console.log('tooltip is shown');
    },
    onShow: () => {
        console.log('tooltip is hidden');
    },
    onToggle: () => {
        console.log('tooltip is toggled');
    },
  }; 

  const handleShowTooltipColor = () => {
    const instanceOptions = {
      id: 'popover-user-profile',
      override: true
    };
    const $targetElColor = document.getElementById('popover-user-profile');
    const $triggerElColor = document.getElementById('color-tooltip');
    const tooltipColor = new Tooltip($targetElColor, $triggerElColor, options, instanceOptions);
    tooltipColor.init()
    tooltipColor.show()
  }

  const handleShowTooltipSettings = () => {
    const $targetElSettings = document.getElementById('popover-settings')
    const $triggerElSettings = document.getElementById('popover-settings-btn');
    const instanceOptionsSetting = {
      id: 'popover-settings',
      override: true
    };
    const tooltipSetting = new Tooltip($targetElSettings, $triggerElSettings, options, instanceOptionsSetting);
    tooltipSetting.init()
    tooltipSetting.show()
  }

  const handleSelectBgColorReadyChange = (option) => {
    setSelectBgColorReady(option)
    setColor(option.value)
  }

  const handleResetToDefault = () => {
    setImageSettings(defaultSettings)
  }

  const handleImageSettingsChange = (e) => {
    let newValue = e.target.value
    if (e.target.name === 'tweetWidth') {
      setImageSettings({
        ...imageSettings,
        tweetHeight: null,
        tweetWidth: newValue
      })
    } else {
      setImageSettings({
        ...imageSettings,
        [e.target.name]: newValue,
      })
    }
    setAspectRatio(null)
  }

  const handleChangeAspectRatio = (e) => {
    const newValue = e.target.value
    setAspectRatio(newValue)
    const height = calculateHeight(newValue).toFixed(0)
    setImageSettings({ ...imageSettings, imageHeight: height })
  }

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type.includes('image')) {
      const reader = new FileReader();
      
      reader.onloadend = () => {
        setImageSrc(reader.result);  // reader.result will be a base64 data URL
      };
  
      reader.readAsDataURL(file);  // Convert the image to a base64 data URL
    } else {
      setImageSrc(null);
    }
  };

  const downloadAsImage = async () => {
    if (codeRef.current === null) {
      return;
    }
    toPng(codeRef.current, {
      cacheBust: true,
      useCORS: true
    })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = `tweet-to-image.png`
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.error('Oops, something went wrong!', err);
      });
  };

  const renderGoldBadge = () => {
    return (
      <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified"><g><linearGradient gradientUnits="userSpaceOnUse" id="25-a" x1="4.411" x2="18.083" y1="2.495" y2="21.508"><stop offset="0" stop-color="#f4e72a"></stop><stop offset=".539" stop-color="#cd8105"></stop><stop offset=".68" stop-color="#cb7b00"></stop><stop offset="1" stop-color="#f4ec26"></stop><stop offset="1" stop-color="#f4e72a"></stop></linearGradient><linearGradient gradientUnits="userSpaceOnUse" id="25-b" x1="5.355" x2="16.361" y1="3.395" y2="19.133"><stop offset="0" stop-color="#f9e87f"></stop><stop offset=".406" stop-color="#e2b719"></stop><stop offset=".989" stop-color="#e2b719"></stop></linearGradient><g clip-rule="evenodd" fill-rule="evenodd"><path d="M13.324 3.848L11 1.6 8.676 3.848l-3.201-.453-.559 3.184L2.06 8.095 3.48 11l-1.42 2.904 2.856 1.516.559 3.184 3.201-.452L11 20.4l2.324-2.248 3.201.452.559-3.184 2.856-1.516L18.52 11l1.42-2.905-2.856-1.516-.559-3.184zm-7.09 7.575l3.428 3.428 5.683-6.206-1.347-1.247-4.4 4.795-2.072-2.072z" fill="url(#25-a)"></path><path d="M13.101 4.533L11 2.5 8.899 4.533l-2.895-.41-.505 2.88-2.583 1.37L4.2 11l-1.284 2.627 2.583 1.37.505 2.88 2.895-.41L11 19.5l2.101-2.033 2.895.41.505-2.88 2.583-1.37L17.8 11l1.284-2.627-2.583-1.37-.505-2.88zm-6.868 6.89l3.429 3.428 5.683-6.206-1.347-1.247-4.4 4.795-2.072-2.072z" fill="url(#25-b)"></path><path d="M6.233 11.423l3.429 3.428 5.65-6.17.038-.033-.005 1.398-5.683 6.206-3.429-3.429-.003-1.405.005.003z" fill="#d18800"></path></g></g></svg>
    )
  }

  const renderBlueBadge = () => {
    return (
      <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-1cvl2hr r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified"><g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g></svg>
    )
  }

  const renderTweet = () => {
    return (
      <div
        className={`tweet-card ${imageSettings.nightMode ? 'dark' : ''}`}
        style={{
          width: imageSettings.tweetWidth ? `${imageSettings.tweetWidth}px` : 'auto',
          height: imageSettings.tweetHeight ? `${imageSettings.tweetHeight}px` : 'auto',
        }}
      >
        <div className="tweet-header">
          { imageSrc && (<img 
            src={imageSrc} 
            className='rounded-full profile-pic'
          />) }
          <div className="tweet-info">
            <span className={`tweet-name`}>
              {inputData.name}
              { inputData.verifiedBadge ==='Golden' && renderGoldBadge() }
              { inputData.verifiedBadge === 'Blue' && renderBlueBadge() }
            </span>
            <span className="tweet-username">@{inputData.username}</span>
          </div>
          <div className="tweet-close">
            <img width={40} alt='X icon' src={imageSettings.nightMode ? xIcons.dark : xIcons.light} />
          </div>
        </div>
  
        {/* Tweet Content */}
        <div className="tweet-body">
          <p>
            <HighlightText text={inputData.content} />
          </p>
        </div>
  
        {/* Footer */}
        <div className="tweet-footer">
          <div className="tweet-hashtags">
            { inputData.tags.split(',').map((tag) => {
              return <span>#{tag.trim()}</span>
            }) }
          </div>
          <div className="tweet-timestamp">{inputData.datetime &&  moment(inputData.datetime).format('h:mm A · MMM D, YYYY')}</div>
        </div>
      </div>
    );
  }

  const HighlightText = ({ text }) => {
    // Regex to match domain-like patterns, hashtags, and mentions
    const patternRegex = /\b([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b|([#@][a-zA-Z0-9-_]+)/g;
  
    // Split the text and wrap matches in <span> for highlighting
    const processedText = text.split(patternRegex).map((part, index) => {
      if (/\b([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b/.test(part)) {
        // Highlight domains
        return (
          <span key={index} className="highlight-domain">
            {part}
          </span>
        );
      } else if (/^#/.test(part)) {
        // Highlight hashtags
        return (
          <span key={index} className="highlight-hashtag">
            {part}
          </span>
        );
      } else if (/^@/.test(part)) {
        // Highlight mentions
        return (
          <span key={index} className="highlight-mention">
            {part}
          </span>
        );
      }
      return part; // Return non-matching text as-is
    });
  
    return <p>{processedText}</p>;
  };
  

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 h-full space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Input Data</h3>
          </div>
          <div className="px-4 py-2 font-medium text-md rounded dark:border-gray-600">
            <button
              className="text-white mt-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
              onClick={() => document.querySelector('input[type="file"]').click()}
            >
              <FontAwesomeIcon
                style={{ width: '18px' }}
                icon={faCloudArrowUp}
              />
              {` `}&nbsp; Browse your avatar
            </button>
            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">X's Name</label>
            <input
              type="text"
              name='name'
              className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required={true}
              placeholder="Enter your X's name here"
              value={inputData.name}
              onChange={handleInputDataChange}
            />
            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">X's Username</label>
            <input
              type="text"
              name='username'
              className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required={true}
              placeholder="Enter your X's username here"
              value={inputData.username}
              onChange={handleInputDataChange}
            />
            <label className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Verified Badge</label>
            <select
              name='verifiedBadge'
              value={inputData.verifiedBadge}
              onChange={(e) => setInputData({...inputData, verifiedBadge: e.target.value }) }
              placeholder='Custom aspect ratio'
              className='bg-gray-50 w-full mr-2 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
            >
              <option value={null}>None</option>
              <option value={`Blue`}>Blue</option>
              <option value={`Golden`}>Golden</option>
            </select>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className='hidden'
            />
            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Content</label>
            <textarea
              id="inputText"
              rows={5}
              name='content'
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Text Goes Here"
              value={inputData.content}
              onChange={handleInputDataChange}
            />
            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Tags</label>
            <input
              type="text"
              name='tags'
              className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Use `,` for multiple tags"
              value={inputData.tags}
              onChange={handleInputDataChange}
            />
            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Datetime</label>
            <Datetime inputProps={{ className: 'w-full bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500' }} className='w-full' name='datetime' value={inputData.datetime} onChange={(value) => setInputData({...inputData, 'datetime': value}) } />
          </div>
        </div>   
      </div>
      <div className="col-span-2">
        <div className="p-4 h-full space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>Tweet preview</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 dark:border-gray-600 flex justify-center">
            {inputData.content && (
              <div className="relative w-full text-center">
                <button
                  onClick={handleShowTooltipColor}
                  id="color-tooltip"
                  type="button"
                  className="text-gray-600 focus:ring-4 border border-gray-200 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-4 text-center dark:focus:ring-blue-800"
                  style={{background: color}}
                >
                  <span style={{color: 'transparent'}} width={40}>C</span>
                </button>
                <div
                  data-popover=""
                  id="popover-user-profile"
                  role="tooltip"
                  className="absolute z-10 invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600"
                >
                  <div className="p-3">
                    <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
                      <ul
                        className="flex flex-wrap -mb-px text-sm font-medium text-center"
                      >
                        <li className="me-2" role="presentation">
                          <button
                            className={colorTab === 0 ? `inline-block p-4 rounded-t-lg border-blue-600 border-b-2` : 'inline-block p-4 rounded-t-lg border-b-2'}
                            type="button"
                            onClick={() => setColorTab(0)}
                          >
                            Ready-to-use
                          </button>
                        </li>
                        <li className="me-2" role="presentation">
                          <button
                            className={colorTab === 1 ? `inline-block p-4 rounded-t-lg border-blue-600 border-b-2` : 'inline-block p-4 rounded-t-lg border-b-2'}
                            type="button"
                            onClick={() => setColorTab(1)}
                          >
                            Customize
                          </button>
                        </li>
                      </ul>
                      <div className='mt-4'>
                        { colorTab === 0 && <Select className='inline-block  w-full' value={selectBgColorReady} options={bgColorReady} onChange={handleSelectBgColorReadyChange} /> }
                        { colorTab === 1 && <ColorPicker value={color} onChange={setColor} /> }
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  onClick={handleShowTooltipSettings}
                  id="popover-settings-btn"
                  type="button"
                  className='text-blue-700 ml-4 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-4 text-center me-2 mb-2 dark:border-blue-500 dark:text-gray-200 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800'
                >
                  <FontAwesomeIcon icon={faSliders}/>
                  &nbsp;Settings
                </button>
                <div
                    data-popover=""
                    id="popover-settings"
                    role="tooltip"
                    className="absolute z-10 invisible inline-block w-84 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600"
                  >
                    <div className="p-3">
                      <form className="max-w-sm mx-auto">
                        <div class="flex items-center ps-4 mb-2  dark:border-gray-700">
                          <input
                            checked={hasBackground}
                            onChange={handleHasBackgroundChange}
                            id="checked-checkbox-2" type="checkbox"
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                          <label for="checked-checkbox-2" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Background</label>
                        </div>
                        <div class="flex items-center ps-4 mb-2  dark:border-gray-700">
                          <input
                            checked={imageSettings.nightMode}
                            onChange={handleNightModeChange}
                            id="checked-checkbox-2" type="checkbox"
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                          <label for="checked-checkbox-2" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Night mode</label>
                        </div>
                        { hasBackground && (
                          <>
                            <div class="flex items-center ps-4  dark:border-gray-700">
                              <label
                                htmlFor="number-input"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Width ({imageSettings.imageWidth})
                              </label>
                              <input min={200} max={2000} onChange={handleImageSettingsChange} name="imageWidth" type="range" value={imageSettings.imageWidth} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                            </div>
                            <div class="flex items-center ps-4  dark:border-gray-700">
                              <label
                                htmlFor="number-input"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Height ({imageSettings.imageHeight})
                              </label>
                              <input min={200} max={2000} onChange={handleImageSettingsChange} name="imageHeight" type="range" value={imageSettings.imageHeight} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                            </div>
                            {/* <div class="flex items-center ps-4  dark:border-gray-700">
                              <label
                                htmlFor="number-input"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Padding Top/Bottom ({imageSettings.paddingY})
                              </label>
                              <input min={0} max={100} onChange={handleImageSettingsChange} name="paddingY" type="range" value={imageSettings.paddingY} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                            </div> */}
                          </>
                        ) }
                        <div class="flex items-center ps-4  dark:border-gray-700">
                          <label
                            htmlFor="number-input"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >
                            Tweet Width ({imageSettings.tweetWidth})
                          </label>
                          <input min={100} max={imageSettings.imageWidth} onChange={handleImageSettingsChange} name="tweetWidth" type="range" value={imageSettings.tweetWidth} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                        </div>
                        <div class="flex items-center ps-4  dark:border-gray-700">
                          <label
                            htmlFor="number-input"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >
                            Tweet Height ({imageSettings.tweetHeight ? imageSettings.tweetHeight : 'auto'})
                          </label>
                          <input min={100} max={imageSettings.imageHeight ? imageSettings.imageHeight : 1000 } onChange={handleImageSettingsChange} name="tweetHeight" type="range" value={imageSettings.tweetHeight} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                        </div>
                        <div class="flex items-center ps-4  dark:border-gray-700">
                          <button
                            type="button"
                            onClick={handleResetToDefault}
                            className="text-white bg-gray-500 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                          >
                            <FontAwesomeIcon icon={faRefresh}/>
                            &nbsp;Reset to default
                          </button>
                        </div>
                      </form> 
                    </div>
                </div>
                <select
                  id="aspect-ratio-select"
                  value={aspectRatio}
                  onChange={(e) => handleChangeAspectRatio(e)}
                  placeholder='Custom aspect ratio'
                  className='bg-gray-50 mr-2 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                >
                  <option value="9:16">9:16 (Portrait)</option>
                  <option value="16:9">16:9 (Landscape)</option>
                  <option value="1:1">1:1 (Square)</option>
                </select>
                <button
                  type="button"
                  onClick={() => downloadAsImage()}
                  className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-[#2557D6]/50 focus:outline-none font-medium rounded-lg text-sm px-5 py-4 text-center inline-flex items-center dark:focus:ring-[#2557D6]/50 me-2 mb-2"
                >
                  <FontAwesomeIcon icon={faCloudArrowDown}/>
                  &nbsp; Download
                </button>
              </div>
            )}
          </div>
          <div className="px-4 py-2 text-gray-400 dark:border-gray-600 flex justify-center">
            { inputData.content && (
              <div
                ref={codeRef}
                className='items-center border rounded-lg justify-center flex'
                style={{
                  background: hasBackground ? color : 'transparent',
                  width: hasBackground ? `${imageSettings.imageWidth}px` : 'auto',
                  height: hasBackground ? `${imageSettings.imageHeight}px` : 'auto',
                  paddingTop: hasBackground ? `${imageSettings.paddingY}px` : 0,
                  paddingBottom: hasBackground ? `${imageSettings.paddingY}px` : 0,
                  paddingLeft: hasBackground ? `${imageSettings.paddingX}px` : 0,
                  paddingRight: hasBackground ? `${imageSettings.paddingX}px` : 0
                }}
              >
                { renderTweet() }
              </div>
            ) }
          </div>
        </div>
      </div>
    </div>
  )
}

export default TweetGenerator;
